/* RAVNAR FINAL MOBILE MENU FIX */
(function(){
  function init(){
    document.addEventListener('click',function(e){
      var summary=e.target.closest('header-drawer details.menu-drawer-container > summary');
      if(!summary || window.innerWidth>989) return;
      var details=summary.parentElement;
      if(!details) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var opening=!details.hasAttribute('open');
      if(opening){
        details.setAttribute('open','');
        details.classList.add('menu-opening');
        summary.setAttribute('aria-expanded','true');
        document.body.classList.add('overflow-hidden-mobile');
        document.documentElement.style.setProperty('--viewport-height',window.innerHeight+'px');
      }else{
        details.classList.remove('menu-opening');
        summary.setAttribute('aria-expanded','false');
        document.body.classList.remove('overflow-hidden-mobile');
        setTimeout(function(){details.removeAttribute('open')},250);
      }
    },true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
